module.exports = __webpack_public_path__ + "img/prgmnglang.17ac6506.svg";